import styled from "styled-components";

export const IndexCtaMainDiv = styled.div`
  align-items: center;
  display: flex;
  flex: none;
  margin: 0 auto;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 106px;
  height: min-content;
  justify-content: center;
  max-width: 966px;
  overflow: hidden;
  padding: 179px 0;
  position: relative;
  width: 100%;
  background-image: url("/images/Inspiration _ Jordan Lloyd_ Photo.gif");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;

  border-left: 1px solid rgb(31, 31, 31);
  border-right: 1px solid rgb(31, 31, 31);
  border-bottom: 1px solid rgb(31, 31, 31);
  .button {
    border-radius: 50px;
    margin: 0 auto;
  }
  .container {
    align-items: center;
    display: flex;
    flex: none;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 40px;
    height: min-content;
    justify-content: flex-start;
    overflow: hidden;
    padding: 0;
    position: relative;
    width: 100%;
    z-index: 2;
  }
  .header {
    outline: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-shrink: 0;
    transform: none;
    flex: none;
    height: auto;
    max-width: 60%;
    position: relative;
    white-space: pre-wrap;
    width: 100%;
    word-break: break-word;
    word-wrap: break-word;
    text-align: center;
    > h3 {
      font-size: 56px;
      font-weight: 500;
      margin: 0;
    }
  }

  @media (max-width: 450px) {
    padding: 36px 0;

  .header {
   
    max-width: 90%;
   
    > h3 {
      font-size: 36px;
     
    }
  }
  }
`;
